import React from 'react'

const StorageForm = () => {
  return (
    <div>StorageForm</div>
  )
}

export default StorageForm